'use client';
import Link from '@/components/WrappedLink';
import Image from 'next/image';

import { websiteLogoAr, websiteLogoEn } from '../../../../public/Images';
import styles from './styles.module.scss';
import Typography from '../typography/typography.component';
import ChangeLanguage from './change-langauge-client.component';
import NavDrawer from './MobileDrawer/drawer-client.component';
import MobileNav from './MobileDrawer/mobile-nav.component';

import { AVAILABLE_LANGUAGES } from '@/constants';
import LinkItemClient from './link-item-client.component';
import HeaderButtonUserLogin from '@/components/auth-components/header-button/header-button.component';
import GetAppHeader from './get-app.component';
import { useTranslation } from '@/hook';

export default function NavBar({ lang }: { lang: AVAILABLE_LANGUAGES }) {
    const { t } = useTranslation();
    const LINKS_DESKTOP = [
        {
            id: 1,
            label: 'Sell Car',
            path: `/${lang}/sell-car`,
        },
        { id: 2, label: 'Finance', path: `/${lang}/car-finance` },
        {
            id: 3,
            label: 'Why Sylndr',
            path: `/${lang}/why-sylndr`,
        },
        {
            id: 4,
            label: 'FAQs',
            path: `/${lang}/how-it-works`,
        },
        {
            id: 5,
            label: 'Blog',
            path: 'https://sylndr.com/ar/blog/home/',
        },
    ];

    return (
        <nav
            className="flex items-center w-full h-[48px] md:h-[80px] px-[5%] bg-white justify-between"
            id="nav-bar"
        >
            <div className={styles.hamLogoContainer}>
                <NavDrawer lang={lang}>
                    <MobileNav lang={lang} />
                </NavDrawer>

                <Link href={`/${lang}`}>
                    <Image
                        width={160}
                        height={25.5}
                        className={styles.logo}
                        src={lang === 'en' ? websiteLogoEn : websiteLogoAr}
                        alt="Sylndr's Logo"
                        dir={lang === 'ar' ? 'rtl' : 'ltr'}
                    />
                </Link>
            </div>
            <ul className={styles.linksSection}>
                <li className={styles.navItem} key={'linkid0'}>
                    <LinkItemClient
                        path={`/${lang}/buy-used-cars`}
                        label={'Buy'}
                    />
                </li>
                {LINKS_DESKTOP.map(link => {
                    return (
                        <li className={styles.navItem} key={link.id}>
                            {link.label === 'Finance' ||
                            link.label === 'Buy' ? (
                                <LinkItemClient
                                    path={link.path}
                                    label={link.label}
                                />
                            ) : (
                                <Link
                                    className={styles.navLink}
                                    href={link.path}
                                >
                                    <Typography variant={'body1Medium'}>
                                        {t(link.label)}
                                    </Typography>
                                </Link>
                            )}
                        </li>
                    );
                })}
                <li className={`${styles.navItem} ${styles.langSelector}`}>
                    <ChangeLanguage lang={lang} />
                </li>
                <li className={`${styles.navItem} ${styles.langSelector}`}>
                    <HeaderButtonUserLogin lang={lang} />
                </li>
            </ul>
            <GetAppHeader />
        </nav>
    );
}
